import React, { useState, useContext } from "react";
import HSLogo from "assets/img/henry-schein-signature.png";
import radioCheck from "assets/img/radio-check.png";
import "assets/css/header.css";
import FooterImage from "assets/img/footer-image.png";
import { useHistory, useLocation } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { footerStyles } from "./style";
import FacebookFilled from "@ant-design/icons/FacebookFilled";
import YoutubeFilled from "@ant-design/icons/YoutubeFilled";
import LinkedinFilled from "@ant-design/icons/LinkedinFilled";
import TwitterSquareFilled from "@ant-design/icons/TwitterSquareFilled";
import InstagramOutlined from "@ant-design/icons/InstagramOutlined"
import Context from "context/context";
import { useTranslation } from 'react-i18next';

//Analytics
import { logEvent } from "helpers/analytics";


export default function DashboardFooter(props) {
  let location = useLocation();
  const classes = footerStyles();
  const { state, dispatch } = useContext(Context);
  const { t, i18n } = useTranslation()
  // let imageOnMyDashBoardView = {
  //   marginLeft: "35%",
  // };
  const lang = i18n.language;
  const org = state?.userInfo?.loyalty_organization_name;
  // let imageOnMyDashBoardVie = {
  //   marginLeft: "5px",
  // };

  return (
    <div className={classes.mainDiv}>
      <div className={classes.secondDiv}>
        <Grid container className={classes.gridContainer}>
        <Grid item xs={12} className={classes.gridItem}>
  <a
    target="_blank"
    href={lang == "en" ? state.redirectionLinks["PRIVACY_STATEMENT"] : state.redirectionLinks["PRIVACY_STATEMENT_FR"]}
    className={classes.ref}
    onClick={() =>
      logEvent({
        event_type: "link_redirect",
        event_name: "Privacy Statement",
        page_url: lang == "en" ? state.redirectionLinks["PRIVACY_STATEMENT"] : state.redirectionLinks["PRIVACY_STATEMENT_FR"],
        user_id: state?.userInfo?.user_id,
        session_id: state?.userInfo?.session_id,
      })
    }
  >
    {t('Privacy Statement')}
  </a>
  <a
    target="_blank"
    href={lang == "en" ? state.redirectionLinks["LEGAL_TERMS_CONDITIONS"] : state.redirectionLinks["LEGAL_TERMS_CONDITIONS_FR"]}
    className={classes.ref}
    onClick={() =>
      logEvent({
        event_type: "link_redirect",
        event_name: "Legal Terms & Conditions",
        page_url: lang == "en" ? state.redirectionLinks["LEGAL_TERMS_CONDITIONS"] : state.redirectionLinks["LEGAL_TERMS_CONDITIONS_FR"],
        user_id: state?.userInfo?.user_id,
        session_id: state?.userInfo?.session_id,
      })
    }
  >
    {t('Legal Terms & Conditions')}
  </a>
  <a
    target="_blank"
    href={lang == "en" ? state.redirectionLinks["PROGRAM_DETAILS"] : state.redirectionLinks["PROGRAM_DETAILS_FR"]}
    className={classes.ref}
    onClick={() =>
      logEvent({
        event_type: "link_redirect",
        event_name: "Program Details",
        page_url: lang == "en" ? state.redirectionLinks["PROGRAM_DETAILS"] : state.redirectionLinks["PROGRAM_DETAILS_FR"],
        user_id: state?.userInfo?.user_id,
        session_id: state?.userInfo?.session_id,
      })
    }
  >
    {t('Program Details')}
  </a>
  <a
    target="_blank"
    href={lang == "en" ? state.redirectionLinks["FAQS"] : state.redirectionLinks["FAQS_FR"]}
    className={classes.ref}
    onClick={() =>
      logEvent({
        event_type: "link_redirect",
        event_name: "FAQs",
        page_url: lang == "en" ? state.redirectionLinks["FAQS"] : state.redirectionLinks["FAQS_FR"],
        user_id: state?.userInfo?.user_id,
        session_id: state?.userInfo?.session_id,
      })
    }
  >
    {t('FAQs')}
  </a>
  <a
    target="_blank"
    href={lang == "en" ? state.redirectionLinks["HENRY_SCHEIN_DENTAL_WEBSITE"] : state.redirectionLinks["HENRY_SCHEIN_DENTAL_WEBSITE_FR"]}
    className={classes.ref}
    onClick={() =>
      logEvent({
        event_type: "link_redirect",
        event_name: org == "Henry Schein Dental" ? "Henry Schein Dental Website" : "Henry Schein Canada Website",
        page_url: lang == "en" ? state.redirectionLinks["HENRY_SCHEIN_DENTAL_WEBSITE"] : state.redirectionLinks["HENRY_SCHEIN_DENTAL_WEBSITE_FR"],
        user_id: state?.userInfo?.user_id,
        session_id: state?.userInfo?.session_id,
      })
    }
  >
    {org == "Henry Schein Dental" ? t('Henry Schein Dental Website') : t('Henry Schein Canada Website')}
  </a>

  <div className={classes.socialIconDivOne}>
    <div className={classes.socialIconDivTwo}>
      <a
        href={state.redirectionLinks["FACEBOOK_ICON"]}
        target="_blank"
        className={classes.socialIconAtag}
        onClick={() =>
          logEvent({
            event_type: "link_redirect",
            event_name: "Facebook",
            page_url: state.redirectionLinks["FACEBOOK_ICON"],
            user_id: state?.userInfo?.user_id,
            session_id: state?.userInfo?.session_id,
          })
        }
      >
        <FacebookFilled className={classes.facebookFilled} />
      </a>
      <a
        href={state.redirectionLinks["TWITTER_ICON"]}
        target="_blank"
        className={classes.socialIconAtag}
        onClick={() =>
          logEvent({
            event_type: "link_redirect",
            event_name: "Twitter",
            page_url: state.redirectionLinks["TWITTER_ICON"],
            user_id: state?.userInfo?.user_id,
            session_id: state?.userInfo?.session_id,
          })
        }
      >
        <TwitterSquareFilled className={classes.twitterFilled} />
      </a>
      <a
        href={state.redirectionLinks["LINKEDIN_ICON"]}
        target="_blank"
        className={classes.socialIconAtag}
        onClick={() =>
          logEvent({
            event_type: "link_redirect",
            event_name: "LinkedIn",
            page_url: state.redirectionLinks["LINKEDIN_ICON"],
            user_id: state?.userInfo?.user_id,
            session_id: state?.userInfo?.session_id,
          })
        }
      >
        <LinkedinFilled className={classes.linkedInFilled} />
      </a>
      <a
        href={state.redirectionLinks["YOUTUBE_ICON"]}
        target="_blank"
        className="youtube-icon"
        onClick={() =>
          logEvent({
            event_type: "link_redirect",
            event_name: "YouTube",
            page_url: state.redirectionLinks["YOUTUBE_ICON"],
            user_id: state?.userInfo?.user_id,
            session_id: state?.userInfo?.session_id,
          })
        }
      >
        <YoutubeFilled />
      </a>
      <a
        href={state.redirectionLinks["INSTAGRAM_ICON"]}
        target="_blank"
        className="instagram-icon"
        onClick={() =>
          logEvent({
            event_type: "link_redirect",
            event_name: "Instagram",
            page_url: state.redirectionLinks["INSTAGRAM_ICON"],
            user_id: state?.userInfo?.user_id,
            session_id: state?.userInfo?.session_id,
          })
        }
      >
        <InstagramOutlined className={classes.instagramIcon} />
      </a>
    </div>
  </div>
</Grid>

        </Grid>
      </div>
    </div>
  );
}
